import React, { useEffect, useState } from 'react';
import { css } from '@compiled/react';
import { defineMessages, useIntl } from 'react-intl';
import Button from '@atlaskit/button/default/button';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import VideoPlayIcon from '@atlaskit/icon/core/video-play';
import { useShortcutStrings } from '@confluence/shortcuts/entry-points/ShortcutVisualizer.ts';

import { contentPresentationService } from '../services/content-presentation-service.ts';

const PRESENT_SHORTCUT = 'mod+option+r';

const tooltipTriggerWrapperStyles = css({
	display: 'inline-block',
});

const i18n = defineMessages({
	label: {
		id: 'content-types-header.content-types.present-slides-button.label',
		defaultMessage: 'Present',
		description: 'Label for the Present button in the header that starts slide presentation mode',
	},
});

export const PresentSlidesButton = (): React.JSX.Element | null => {
	const intl = useIntl();
	const [isAvailable, setIsAvailable] = useState(contentPresentationService.isAvailable);
	const [isPresentSlidesEnabled, setIsPresentSlidesEnabled] = useState(
		contentPresentationService.isPresentSlidesEnabled,
	);
	const shortcutStrings = useShortcutStrings({ shortcut: PRESENT_SHORTCUT });

	useEffect(() => {
		return contentPresentationService.onAvailabilityChange(setIsAvailable);
	}, []);

	useEffect(() => {
		return contentPresentationService.onPresentSlidesEnabledChange(setIsPresentSlidesEnabled);
	}, []);

	if (!isAvailable) {
		return null;
	}

	const label = intl.formatMessage(i18n.label);

	const button = (
		<Button
			iconBefore={VideoPlayIcon}
			isDisabled={!isPresentSlidesEnabled}
			onClick={() => contentPresentationService.startPresent()}
		>
			{label}
		</Button>
	);

	return isPresentSlidesEnabled ? (
		<Tooltip content={label} shortcut={shortcutStrings}>
			{/* Span wrapper so the tooltip can attach hover to a non-button wrapper when needed. */}
			<span css={tooltipTriggerWrapperStyles}>{button}</span>
		</Tooltip>
	) : (
		button
	);
};
